var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStayInformedBottomBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1224,
    height: 150,
    viewBox: "0 0 1224 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-106.881 202.196C-52.3382 201.818 6.66818 205.08 60.2622 198.623C147.558 188.104 228.244 162.871 314.612 150.176C346.566 145.475 376.903 143.029 407.889 151.182C434.322 158.127 456.201 170.323 476.812 182.214C513.19 203.227 551.935 232.02 605.09 235.648C639.191 237.978 672.774 226.776 701.513 216.953C733.967 205.861 764.793 193.092 797.237 181.988C826.646 171.921 861.566 160.176 896.517 163.219C926.584 165.835 952.268 178.299 974.077 190.336C1016.41 213.69 1060.86 251.228 1124.86 247.777C1199.52 243.746 1255.24 204.964 1331.05 202.196",
    stroke: "url(#paint0_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.861 195.166C-52.0091 194.714 6.83749 198.885 60.761 192.05C146.28 181.208 224.858 155.646 309.409 142.658C341.633 137.694 371.261 135.481 402.596 143.53C429.438 150.426 452.196 162.305 473.576 174.104C511.173 194.836 551.705 223.526 604.81 228.033C638.602 230.905 671.925 219.935 700.404 210.154C732.309 199.178 762.486 186.489 794.371 175.519C823.69 165.433 858.28 154.024 893.071 157.5C923.168 160.512 949.311 173.031 971.61 184.94C1014.5 207.806 1060.41 244.405 1123.92 241.003C1198.91 236.99 1254.94 197.958 1331.08 195.202",
    stroke: "url(#paint1_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.841 188.269C-51.6091 187.836 7.2075 193.11 61.5105 185.927C145.072 174.884 221.364 149.06 303.927 135.846C336.281 130.669 365.35 128.724 396.945 136.541C424.266 143.298 447.873 154.835 470.081 166.42C509.246 186.781 551.196 215.056 604.451 220.392C637.844 223.733 670.577 213.239 698.777 203.525C729.983 192.769 759.391 180.189 790.577 169.42C819.786 159.329 853.708 148.487 888.289 152.347C918.526 155.731 945.208 168.201 968.175 179.945C1011.92 202.306 1059.48 237.783 1122.65 234.398C1198.09 230.355 1254.55 191.061 1331.15 188.287",
    stroke: "url(#paint2_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.831 181.507C-51.15 181.165 7.64666 187.708 62.439 180.214C143.903 169.074 217.769 143.018 298.205 129.731C330.539 124.377 359.208 122.712 390.963 130.188C418.774 136.737 443.209 147.872 466.326 159.104C507.268 179.001 550.497 206.599 603.951 212.703C668.46 220.075 733.647 181.708 785.923 163.622C815.022 153.549 848.025 143.457 882.307 147.683C912.784 151.445 940.025 163.793 963.781 175.36C1008.64 197.197 1057.97 231.405 1120.98 228.002C1196.98 223.905 1253.98 184.324 1331.13 181.507",
    stroke: "url(#paint3_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.812 174.884C-50.6412 174.695 8.16549 182.641 63.527 174.884C142.805 163.738 214.124 137.56 292.323 124.23C324.547 118.742 352.937 117.376 384.782 124.419C413.101 130.694 438.386 141.334 462.412 152.213C505.131 171.543 549.648 198.221 603.372 205.081C666.902 213.178 729.283 175.921 780.59 158.128C808.96 148.304 842.033 138.401 875.376 143.462C906.332 148.158 933.604 159.542 958.708 171.128C1004.85 192.409 1056.08 225.234 1119.09 221.795C1195.74 217.618 1253.35 177.738 1331.15 174.842",
    stroke: "url(#paint4_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.791 168.39C-50.0914 168.39 8.77515 177.86 64.7558 169.817C141.777 158.749 210.479 132.462 286.372 119.205C418.185 96.1619 486.947 181.232 602.733 197.513C665.145 206.3 724.371 170.384 774.749 152.95C802.989 143.194 834.784 134.31 867.708 139.657C899.053 144.749 926.964 155.883 953.076 167.25C1000.66 187.982 1053.87 219.313 1117.01 215.819C1194.37 211.55 1252.66 171.36 1331.18 168.39",
    stroke: "url(#paint5_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.771 162.037C-49.5226 162.293 9.44376 173.317 66.0934 165.037C140.818 154.116 206.894 127.767 280.42 114.626C409.507 91.5646 488.125 172.555 602.044 190.001C663.377 199.404 719.048 165.079 768.508 147.981C796.628 138.261 827.035 130.548 859.489 136.139C891.254 141.627 919.873 152.481 947.035 163.61C996.145 183.732 1051.39 213.557 1114.8 209.983C1192.92 205.587 1251.93 165.104 1331.21 162.037",
    stroke: "url(#paint6_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.751 155.817C-48.9329 156.335 10.1533 168.97 67.512 160.482C139.949 149.762 203.319 123.383 274.568 110.419C400.919 87.4245 489.264 163.988 601.335 182.599C661.57 192.599 713.456 159.964 762.047 143.201C790.068 133.536 818.967 127.06 850.921 132.835C883.126 138.682 912.484 149.299 940.724 160.153C991.412 179.666 1048.69 207.935 1112.42 204.282C1191.31 199.752 1251.1 158.964 1331.17 155.793",
    stroke: "url(#paint7_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.731 149.731C-48.3542 150.517 10.9018 164.768 69.0194 156.103C139.22 145.627 199.974 119.236 268.926 106.491C392.591 83.6309 490.382 155.597 600.616 175.323C659.762 185.909 707.754 155.011 755.516 138.572C783.417 128.968 810.908 123.766 842.333 129.748C874.987 135.968 905.114 146.316 934.413 156.902C986.688 175.805 1045.98 202.513 1110.11 198.769C1189.83 194.11 1250.36 153.036 1331.23 149.731",
    stroke: "url(#paint8_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.712 143.786C-47.7954 144.834 11.6603 160.664 70.4469 151.853C138.49 141.651 196.678 115.266 263.433 102.772C384.652 80.0882 491.51 147.371 599.956 168.201C658.024 179.36 702.112 150.2 749.095 134.053C776.876 124.51 803.018 120.584 833.845 126.736C866.948 133.334 897.834 143.444 928.181 153.737C981.995 171.994 1043.27 197.196 1107.84 193.373C1188.35 188.586 1249.64 147.176 1331.29 143.798",
    stroke: "url(#paint9_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.691 137.969C-47.1858 139.267 12.4098 156.616 71.9154 147.682C137.912 137.774 193.643 111.407 258.321 99.1807C377.213 76.7043 492.619 139.316 599.248 161.25C656.347 172.994 696.49 145.451 742.824 129.627C770.515 120.175 795.29 117.431 825.597 123.761C859.129 130.737 890.765 140.646 922.1 150.64C977.392 168.268 1040.55 191.989 1105.57 188.068C1186.84 183.159 1248.85 141.45 1331.25 137.969",
    stroke: "url(#paint10_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.671 132.291C-46.606 133.804 13.1592 152.579 73.3339 143.554C137.443 133.944 190.867 107.577 253.608 95.6377C314.472 84.0519 379.22 97.1316 436.07 111.108C490.892 124.59 543.008 142.273 598.649 154.499C655.029 166.89 690.988 140.645 736.973 125.23C798.037 104.772 860.578 130.718 916.469 147.542C973.098 164.567 1038.04 186.873 1103.48 182.866C1185.48 177.854 1248.16 135.852 1331.29 132.285",
    stroke: "url(#paint11_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.652 126.743C-46.0283 128.432 13.747 148.506 74.6906 139.414C137.092 130.097 188.389 103.748 249.443 92.071C309.747 80.5218 376.203 93.0649 433.322 105.864C489.253 118.401 542.487 134.957 598.118 147.981C653.75 161.006 686.244 136.048 731.639 120.852C791.315 100.882 856.462 128.78 911.384 144.42C969.202 160.884 1035.79 181.836 1101.59 177.775C1184.23 172.671 1247.53 130.389 1331.27 126.743",
    stroke: "url(#paint12_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.632 121.334C-45.4386 123.163 14.2867 144.359 75.9393 135.212C136.853 126.181 186.263 99.8452 245.699 88.3936C305.544 76.8993 373.517 88.9302 430.896 100.668C487.815 112.321 542.118 127.883 597.66 141.706C623.863 148.225 643.065 148.493 668.399 140.084C688.99 133.249 706.406 123.322 726.966 116.437C754.398 107.242 776.247 107.498 804.976 114.334C839.497 122.559 873.129 132.017 907.001 141.206C965.788 157.109 1033.82 176.842 1099.93 172.744C1183.13 167.585 1246.96 125.023 1331.3 121.334",
    stroke: "url(#paint13_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.611 116.053C-44.8489 117.882 14.6967 140.091 77.0683 130.913C136.774 122.127 184.496 95.6927 242.733 84.5338C302.269 73.1248 371.491 84.6557 429.099 95.5098C486.708 106.364 542.019 121.12 597.381 135.755C622.964 142.517 641.668 143.475 666.782 135.109C686.694 128.474 703.31 118.681 723.172 111.998C750.454 102.815 771.963 103.791 800.193 110.852C834.884 119.529 869.036 128.968 903.547 137.901C963.072 153.304 1032.43 171.939 1098.64 167.829C1182.3 162.64 1246.56 119.822 1331.31 116.108",
    stroke: "url(#paint14_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.592 110.918C-44.2502 112.699 14.9559 135.675 78.0265 126.474C136.843 117.882 183.078 91.247 240.506 80.4174C299.962 69.1914 369.933 80.1979 427.9 90.2775C486.338 100.43 542.129 114.571 597.26 130.011C622.325 137.023 640.819 138.499 665.743 130.133C685.116 123.638 701.063 113.906 720.376 107.351C747.527 98.1375 769.017 99.6315 796.818 106.961C831.558 116.108 866.109 125.571 901.15 134.316C961.065 149.273 1031.58 166.945 1097.74 162.865C1181.73 157.682 1246.3 114.62 1331.41 110.918",
    stroke: "url(#paint15_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.571 105.913C-43.6605 107.529 15.0363 131.06 78.8059 121.834C137.013 113.413 182.249 86.6625 238.989 75.9609C298.255 64.7897 369.144 75.5584 427.262 85.01C486.298 94.6139 542.339 108.371 597.211 124.645C621.866 131.963 640.46 133.731 665.255 125.31C684.228 118.865 699.676 109.127 718.619 102.62C745.671 93.3273 767.46 95.0835 794.931 102.748C829.602 112.419 864.412 121.95 899.842 130.548C959.937 145.128 1031.28 162.007 1097.16 157.988C1181.35 152.86 1246.08 109.566 1331.39 105.913",
    stroke: "url(#paint16_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.542 101.034C-43.3116 102.485 14.9757 126.273 79.1348 116.962C137.143 108.547 182.109 81.8201 238.669 71.1795C297.875 60.045 369.084 71.0331 427.221 80.2835C486.467 89.7106 542.328 103.364 597.27 119.712C621.835 127.029 640.689 128.553 665.314 120.187C684.157 113.785 699.505 104.132 718.349 97.7109C745.31 88.5277 767.499 90.235 794.71 98.1195C829.231 108.12 864.082 117.724 899.662 126.236C959.467 140.548 1031.73 157.237 1097.11 153.067C1181.18 147.713 1246.33 105.15 1331.42 101.052",
    stroke: "url(#paint17_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.521 96.2349C-43.1513 97.613 14.9663 121.559 79.2751 112.138C137.193 103.65 182.389 77.1489 238.989 66.5753C298.195 55.514 369.244 66.9839 427.292 76.2952C486.348 85.7711 541.969 99.3996 597.291 114.973C649.657 129.712 675.61 107.046 718.739 92.9116C745.7 84.0759 768.029 85.6857 794.991 93.6007C829.362 103.692 864.153 113.272 899.722 121.687C959.178 135.748 1032.38 152.517 1097.29 147.993C1181 142.151 1246.95 101.32 1331.47 96.3264",
    stroke: "url(#paint18_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.502 91.5097C-42.9421 92.8391 15.0358 116.962 79.5443 107.462C137.462 98.9246 182.838 72.7042 239.468 62.2282C298.674 51.2522 369.513 63.1612 427.471 72.503C486.298 81.985 541.709 95.5526 597.35 110.34C649.277 124.145 676.159 101.882 719.317 88.3877C746.279 79.9362 768.807 81.4972 795.529 89.4243C829.741 99.571 864.432 109.077 899.991 117.346C959.207 131.121 1033.14 147.713 1097.51 142.884C1180.8 136.639 1247.56 97.5831 1331.46 91.7963",
    stroke: "url(#paint19_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.481 86.8695C-42.7019 88.1623 15.1861 112.48 79.9343 102.937C137.782 94.4125 183.428 68.4909 240.097 58.1246C299.303 47.3316 369.913 59.5393 427.761 68.8872C486.308 78.3388 541.6 91.8026 597.441 105.773C648.998 118.657 676.798 96.8882 720.067 84.0219C747.099 75.9911 769.796 77.5522 796.319 85.4732C830.341 95.6381 864.961 105.035 900.461 113.108C959.527 126.554 1033.91 142.737 1097.84 137.658C1180.72 131.078 1248.25 93.8576 1331.51 87.3574",
    stroke: "url(#paint20_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.462 82.3081C-42.4127 83.5886 15.3654 108.096 80.4431 98.5465C138.241 90.0706 184.166 64.4416 240.886 54.2827C300.072 43.6787 370.322 56.1608 428.15 65.4782C486.378 74.8688 541.5 88.1924 597.57 101.321C648.738 113.303 677.517 92.1072 720.985 79.9361C748.107 72.3382 770.984 73.9541 797.337 81.8508C831.093 92.0674 865.731 101.158 901.1 109.083C960.116 122.157 1034.71 137.743 1098.27 132.432C1180.61 125.584 1248.97 90.2413 1331.5 83.1252",
    stroke: "url(#paint21_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.432 77.832C-42.0928 79.1126 15.6653 103.833 81.0626 94.296C138.811 85.8872 185.045 60.5997 241.835 50.6481C301.001 40.2819 370.952 52.9592 428.67 62.2339C486.588 71.5269 541.56 84.6676 597.76 96.9425C648.548 108.04 678.366 87.4726 722.094 76.0393C749.345 68.911 772.393 70.6184 798.595 78.4784C832.148 88.6273 866.66 97.5479 901.949 105.193C960.995 117.858 1035.58 132.596 1098.8 127.145C1180.61 120.09 1249.75 86.6799 1331.56 79.0089",
    stroke: "url(#paint22_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.412 73.454C-41.7438 74.7406 16.0043 99.6744 81.7711 90.2106C139.479 81.9055 186.043 56.9839 242.853 47.2701C301.989 37.16 371.57 49.9897 429.238 59.1852C486.727 68.3318 541.679 81.2652 597.939 92.668C648.368 102.894 679.284 83.0275 723.312 72.3686C750.713 65.7342 773.94 67.5696 800.033 75.4174C833.356 85.4694 867.713 94.1892 902.887 101.522C962.033 113.718 1036.39 127.474 1099.34 121.895C1180.58 114.699 1250.46 83.2592 1331.54 75.1187",
    stroke: "url(#paint23_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.392 69.1611C-41.3638 70.4782 16.4343 95.6498 82.5805 86.2349C140.249 78.076 187.152 53.5508 244.022 44.0992C303.118 34.2818 372.32 47.203 429.858 56.2948C486.947 65.3195 541.839 77.9602 598.12 88.4849C648.199 97.845 680.273 78.7285 724.63 68.8867C752.201 62.7889 775.608 64.7646 801.621 72.5454C834.724 82.4781 868.938 90.9651 904.006 97.9426C963.342 109.669 1037.28 122.261 1100 116.583C1180.65 109.266 1251.25 79.8688 1331.57 71.3075",
    stroke: "url(#paint24_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.372 64.9657C-40.9548 66.3194 16.8333 91.7349 83.4688 82.448C141.097 74.4111 188.37 50.3005 245.299 41.1417C304.346 31.6474 373.118 44.6113 430.577 53.5872C487.266 62.4473 542.109 74.7709 598.339 84.4054C648.078 92.9423 681.381 74.6063 726.088 65.612C753.848 60.0326 777.435 62.2217 803.388 69.8805C836.259 79.6626 870.311 87.8903 905.244 94.4911C964.809 105.681 1038.15 116.974 1100.69 111.229C1180.74 103.912 1252.01 76.5332 1331.57 67.6182",
    stroke: "url(#paint25_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.352 60.8747C-40.5249 62.2772 17.3231 87.9366 84.3781 78.7778C142.036 70.9299 189.679 47.234 246.678 38.3922C305.664 29.2455 373.958 42.2033 431.416 51.0451C487.686 59.7161 542.489 71.686 598.659 80.4242C648.059 88.1135 682.66 70.6311 727.736 62.5272C755.696 57.5026 779.453 59.9051 805.386 67.5274C838.018 77.1378 871.9 85.0779 906.682 91.266C966.478 101.882 1039.07 111.785 1101.48 105.974C1180.9 98.6138 1252.81 73.369 1331.61 64.1492",
    stroke: "url(#paint26_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.332 56.9046C-40.0959 58.3497 17.822 84.2531 85.4661 75.2467C143.034 67.5757 191.076 44.3431 248.135 35.8367C307.052 27.0498 374.876 39.9771 432.205 48.6421C488.065 57.1058 542.828 68.6794 598.878 76.5272C647.969 83.4055 683.938 66.7708 729.363 59.5998C757.523 55.1423 781.469 57.7704 807.413 65.3378C839.798 74.756 873.498 82.3862 908.11 88.1374C968.295 98.1377 1039.99 106.492 1102.29 100.693C1181.1 93.3753 1253.58 70.2526 1331.63 60.7705",
    stroke: "url(#paint27_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.312 53.002C-39.5961 54.5325 18.4316 80.6859 86.5551 71.8502C144.113 64.3926 192.575 41.6235 249.674 33.4708C308.54 25.0742 375.855 37.9283 433.104 46.4469C488.545 54.6972 543.268 65.8317 599.168 72.7893C647.969 78.887 685.356 63.1487 731.121 56.935C759.491 53.063 783.617 55.9716 809.6 63.4353C841.739 72.6423 875.252 79.9423 909.678 85.2348C970.232 94.5766 1040.93 101.327 1103.15 95.5218C1181.34 88.2349 1254.34 67.3196 1331.65 57.618",
    stroke: "url(#paint28_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.292 49.2274C-39.0972 50.8372 19.0303 77.2405 87.723 68.6C145.231 61.3619 194.082 39.0746 251.281 31.2938C310.068 23.2935 376.863 36.0562 434.022 44.3857C489.064 52.4043 543.717 63.0693 599.438 69.1366C647.989 74.4234 686.824 59.6363 732.938 54.3495C761.508 51.075 785.803 54.2702 811.876 61.6668C843.765 70.6449 877.084 77.5924 911.305 82.3993C972.219 91.0337 1041.84 96.107 1104.03 90.3264C1181.61 83.1249 1255.07 64.4169 1331.67 54.5202",
    stroke: "url(#paint29_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.272 45.5694C-38.6084 47.2645 19.669 73.9179 88.8909 65.4847C146.409 58.4784 195.67 36.6849 252.938 29.2883C311.645 21.7088 377.911 34.3434 435.03 42.4778C489.683 50.2646 544.255 60.4174 599.797 65.6006C648.138 70.1068 688.451 56.2832 734.895 51.972C763.674 49.2951 788.14 52.7952 814.313 60.0821C845.953 68.8279 879.077 75.4167 913.083 79.7291C974.406 87.6135 1042.84 90.9551 1105.01 85.2171C1181.9 78.1071 1255.8 61.6553 1331.69 51.594",
    stroke: "url(#paint30_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.253 42.0258C-38.0995 43.8125 20.3276 70.6854 90.1187 62.5082C147.637 55.7458 197.307 34.4463 254.645 27.4521C313.272 20.3177 378.999 32.7938 436.048 40.7209C490.331 48.2638 544.804 57.8739 600.106 62.179C648.277 65.9291 690.058 53.0872 736.802 49.7517C765.761 47.6846 790.416 51.5018 816.689 58.6971C848.084 67.1942 881.007 73.4058 914.78 77.2039C976.492 84.2956 1043.72 85.8749 1105.89 80.1796C1182.22 73.1915 1256.41 59.0142 1331.64 48.8065",
    stroke: "url(#paint31_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.232 38.6111C-37.5797 40.4892 21.0172 67.6365 91.3674 59.6728C148.876 53.1542 198.985 32.3669 256.394 25.8057C314.921 19.0982 380.098 31.434 437.137 39.1416C491.061 46.4589 545.414 55.4775 600.486 58.9105C648.568 61.9106 691.776 50.0688 738.88 47.715C768.048 46.2577 792.803 50.4102 819.325 57.5081C850.478 65.752 883.201 71.5781 916.727 74.8501C1057.53 89.0518 1195.5 65.0937 1331.78 46.1906",
    stroke: "url(#paint32_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.212 35.3065C-37.05 37.2883 21.7167 64.6734 92.6462 56.9597C150.155 50.7034 200.693 30.4344 258.172 24.2574C316.599 17.9766 381.227 30.16 438.146 37.642C491.76 44.7093 545.954 53.1425 600.776 55.6853C648.848 57.9354 693.415 47.1484 740.867 45.7459C770.206 44.8922 795.17 49.4046 821.842 56.3987C852.639 64.5271 885.342 69.7102 918.545 72.5761C1055.76 84.4241 1198.88 62.4294 1331.75 43.6544",
    stroke: "url(#paint33_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.192 32.1354C-36.5212 34.2208 22.4253 61.8438 93.9339 54.3862C151.452 48.3677 202.41 28.6414 259.959 22.879C318.286 17.0434 382.355 29.0621 439.214 36.2941C492.539 43.0931 546.542 50.9287 601.115 52.6422C649.277 54.1545 695.102 44.3858 742.914 43.9773C772.422 43.7273 797.546 48.5933 824.428 55.5021C855.025 63.3621 887.509 68.1001 920.432 70.4538C983.153 74.9357 1046.75 71.1185 1108.95 65.6366C1183.59 59.0571 1258.33 51.8373 1331.77 41.2455",
    stroke: "url(#paint34_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.172 29.0921C-36.5905 31.2447 22.276 58.9164 93.7148 52.0991C151.004 46.6111 202.061 27.6531 259.16 21.9029C316.878 16.0917 379.659 27.6226 436.019 34.5862C490.502 41.2938 545.694 48.788 601.465 49.727C650.975 50.5624 699.216 41.3304 748.616 42.4097C778.434 43.0622 803.289 49.0136 830.62 55.6236C859.01 62.4897 888.987 66.4227 919.305 68.2825C983.833 72.24 1047.83 66.4044 1111.59 60.8981C1185.19 54.5443 1259.44 49.6538 1331.82 39.0315",
    stroke: "url(#paint35_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.162 26.184C-36.1014 28.4402 23.0048 56.3436 94.9728 49.7885C152.272 44.5688 203.739 26.1109 260.928 20.7814C318.526 15.4398 380.808 26.806 437.088 33.5441C491.311 40.0443 546.293 46.9592 601.774 46.9592C651.574 46.9592 700.884 38.9528 750.693 40.9955C780.551 42.2151 805.615 48.508 833.156 54.9777C861.356 61.5999 891.134 65.1183 921.192 66.5086C985.93 69.5026 1048.82 61.8011 1112.57 56.4473C1185.69 50.3068 1259.93 47.6909 1331.8 36.9344",
    stroke: "url(#paint36_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.143 23.416C-35.5526 25.7758 23.6734 53.9049 96.2505 47.6059C153.569 42.6301 205.436 24.6904 262.705 19.7756C320.183 14.8303 381.975 26.1173 438.226 32.6358C492.149 38.8982 546.922 45.1911 602.113 44.3009C652.272 43.4899 702.551 36.6847 752.78 39.6788C782.677 41.4654 807.942 48.0937 835.662 54.4232C863.623 60.8075 893.261 63.9113 923.038 64.8321C987.946 66.8504 1049.8 57.3196 1113.53 52.1121C1186.19 46.1729 1260.32 45.8436 1331.77 34.953",
    stroke: "url(#paint37_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.123 20.7881C-35.0438 23.2272 24.4319 51.594 97.5183 45.5572C154.847 40.8193 207.113 23.3674 264.472 18.8917C321.83 14.4159 383.123 25.5504 439.224 31.8433C493.018 37.8801 547.53 43.5816 602.422 41.7949C653.021 40.1485 704.158 34.5629 754.807 38.496C784.764 40.8193 810.208 47.8073 838.188 53.9905C866.169 60.1736 895.427 62.8322 924.925 63.2957C989.833 64.3262 1050.87 53.0087 1114.53 47.9476C1186.76 42.2035 1260.84 44.1547 1331.81 33.1056",
    stroke: "url(#paint38_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.112 18.2999C-34.5438 20.861 25.1416 49.3986 98.7473 43.6423C156.106 39.136 208.751 22.2147 266.19 18.117C323.389 14.0376 384.302 25.099 440.303 31.1784C493.937 36.9957 548.15 42.0996 602.773 39.4348C653.87 36.9408 705.767 32.5687 756.864 37.4226C786.732 40.2641 812.475 47.618 840.656 53.6609C868.316 59.588 897.575 61.8685 926.753 61.8868C991.661 61.9356 1051.92 48.8864 1115.49 43.9594C1187.38 38.386 1261.28 42.6118 1331.81 31.3858",
    stroke: "url(#paint39_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.103 15.9648C-34.0547 18.6113 25.8105 47.3867 99.9454 41.8499C157.334 37.5815 210.359 21.1175 267.867 17.4588C325.006 13.8001 385.311 24.7761 441.321 30.6422C494.845 36.2277 548.789 40.7584 603.092 37.2278C654.739 33.874 707.304 30.7154 758.871 36.4717C788.729 39.7949 814.692 47.5208 843.082 53.4235C870.613 59.1432 899.622 61.0152 928.531 60.6005C993.339 59.6798 1052.96 44.9598 1116.44 40.1486C1187.93 34.7338 1261.64 41.234 1331.84 29.7824",
    stroke: "url(#paint40_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.082 13.7754C-33.5848 16.5133 26.49 45.4838 101.114 40.1909C158.533 36.1115 211.957 20.1781 269.496 16.867C326.515 13.5864 386.33 24.5441 442.311 30.1906C495.735 35.5627 549.409 39.5263 603.402 35.1481C655.628 30.9162 708.843 28.9528 760.769 35.5932C790.597 39.4043 816.78 47.4961 845.419 53.2768C872.78 58.7648 901.639 60.277 930.299 59.4416C994.937 57.5696 1054.05 41.252 1117.42 36.5445C1188.57 31.2577 1262.06 40.0141 1331.92 28.3369",
    stroke: "url(#paint41_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.072 11.7383C-33.1756 14.5616 27.1189 43.7394 102.222 38.66C159.671 34.7696 213.395 19.3178 271.063 16.3726C327.982 13.47 387.358 24.4095 443.249 29.8609C496.603 35.0745 550.008 38.4404 603.682 33.2329C656.517 28.1108 710.211 27.3181 762.586 34.8184C792.354 39.0868 818.787 47.5444 847.616 53.191C874.837 58.5204 903.536 59.6241 931.896 58.3924C996.305 55.5935 1055.01 37.7697 1118.26 33.1232C1189.16 27.934 1262.35 38.9344 1331.9 26.9766",
    stroke: "url(#paint42_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.062 9.86621C-32.7065 12.7566 27.7478 42.1295 103.271 37.2513C160.769 33.5439 214.823 18.5494 272.551 15.964C329.38 13.4212 388.297 24.3606 444.138 29.6413C497.442 34.6842 550.587 37.4891 603.961 31.4706C657.335 25.4521 711.558 25.8058 764.344 34.1354C794.042 38.8245 820.734 47.5505 849.723 53.1726C876.684 58.4106 905.424 59.0692 933.434 57.441C997.583 53.7824 1055.96 34.5195 1119.08 29.934C1189.67 24.8058 1262.65 38.0318 1331.9 25.7509",
    stroke: "url(#paint43_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.002 8.12305C-32.2465 11.0744 28.3376 40.6425 104.31 35.9533C161.788 32.4227 216.161 17.8795 273.959 15.6294C330.659 13.422 389.196 24.398 444.977 29.5262C498.251 34.4045 551.146 36.6789 604.211 29.8677C658.275 22.9345 712.817 24.3797 765.982 33.5264C795.62 38.6119 822.542 47.6671 851.7 53.21C878.552 58.3138 907.142 58.6065 934.862 56.6491C965.11 54.5088 994.598 49.6062 1023.64 44.167C1054.97 38.307 1087.22 29.3677 1119.86 27.0018C1190.21 21.8979 1262.94 37.3192 1331.91 24.6724",
    stroke: "url(#paint44_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.002 6.59766C-31.887 9.59776 28.8069 39.3549 105.219 34.8243C162.747 31.4095 217.41 17.2688 275.278 15.3541C331.887 13.4577 390.005 24.5007 445.736 29.5009C499.01 34.2694 551.696 36.0072 604.451 28.4277C659.103 20.5738 714.006 23.0677 767.56 33.0071C797.068 38.4951 824.219 47.8247 853.528 53.2883C880.27 58.2702 908.73 58.2336 936.181 55.9408C966.368 53.4286 995.686 48.0991 1024.56 42.3123C1055.66 36.0804 1087.96 26.6776 1120.59 24.2934C1190.72 19.1774 1263.22 36.7633 1331.92 23.6836",
    stroke: "url(#paint45_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.002 5.21387C-31.5475 8.26275 29.3062 38.1967 106.047 33.8002C163.616 30.4952 218.538 16.7813 276.456 15.141C332.986 13.5373 390.714 24.7085 446.405 29.5806C499.689 34.2332 552.185 35.4832 604.631 27.1415C659.912 18.379 715.064 21.8547 768.998 32.5563C798.396 38.3858 825.747 48.002 855.205 53.4046C881.838 58.2828 910.127 57.9413 937.379 55.3498C967.496 52.4838 996.665 46.7519 1025.38 40.648C1056.28 34.0807 1088.61 24.2633 1121.25 21.8425C1191.15 16.6594 1263.48 36.3857 1331.95 22.8364",
    stroke: "url(#paint46_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.002 4C-31.2379 7.04889 29.7156 37.1902 106.786 32.8974C164.425 29.6838 219.626 16.348 277.604 14.976C334.074 13.6345 391.443 24.9702 447.074 29.7448C500.378 34.312 552.724 35.0986 604.85 26.0435C660.701 16.3419 715.993 20.7323 770.306 32.1412C799.604 38.3061 827.135 48.1723 856.713 53.5261C883.256 58.3251 911.446 57.7153 938.437 54.8493C968.515 51.6541 997.524 45.5563 1026.11 39.1598C1056.84 32.2754 1089.19 22.1226 1121.87 19.6469C1191.63 14.354 1263.78 36.1719 1331.95 22.086",
    stroke: "url(#paint47_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.002 2.96387C-30.9483 6.01275 30.0652 36.3431 107.435 32.1173C165.084 28.9709 220.535 15.9887 278.563 14.8301C334.973 13.7264 391.962 25.2634 447.593 29.9709C500.928 34.4833 553.174 34.8491 605 25.0927C661.43 14.4643 716.752 19.684 771.464 31.8002C800.633 38.2639 828.324 48.3557 858.011 53.673C884.474 58.417 912.524 57.5755 939.326 54.4657C969.364 50.9716 998.243 44.5446 1026.71 37.8797C1057.3 30.7148 1089.62 20.2998 1122.39 17.7571C1192 12.2996 1264.06 36.1723 1331.96 21.4645",
    stroke: "url(#paint48_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.002 2.09766C-31.3178 5.14654 29.496 35.4769 106.417 31.5438C167.201 28.44 225.957 14.4213 287.29 14.7079C339.726 14.9518 392.342 25.4704 444.138 29.995C499.17 34.8 551.845 34.6659 605.14 24.3789C664.236 13.0005 719.608 18.9824 776.567 32.5134C802.101 38.5745 826.426 46.8431 852.15 52.5202C879.371 58.5265 909.259 57.9411 937.269 54.6056C969.054 50.825 999.481 43.6296 1029.46 36.3123C1059.68 28.9096 1091.8 18.4885 1124.38 16.0494C1193.29 10.9211 1264.94 36.2391 1331.95 20.9703",
    stroke: "url(#paint49_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.002 1.41504C-31.1081 4.42124 29.7057 34.9528 106.836 31.0136C167.64 27.9038 226.666 14.2143 287.98 14.6716C340.375 15.068 392.721 25.8793 444.488 30.41C499.56 35.2272 552.225 34.7516 605.26 23.7939C664.955 11.452 720.037 18.1351 777.466 32.3308C802.88 38.6115 827.275 46.9532 853.068 52.6363C880.23 58.6488 909.988 57.9414 937.838 54.4169C969.603 50.3985 999.91 42.8921 1029.8 35.3796C1059.98 27.794 1092.09 17.2571 1124.75 14.696C1193.53 9.34215 1265.26 36.5565 1331.96 20.5499",
    stroke: "url(#paint50_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.002 0.926758C-30.9583 3.88418 29.8055 34.5987 107.156 30.5985C167.97 27.4521 227.126 14.0553 288.519 14.6589C340.895 15.1712 392.991 26.3301 444.737 30.8973C499.839 35.7755 552.584 35.0011 605.28 23.3849C665.554 10.1039 720.197 17.3481 778.115 32.1413C803.469 38.611 827.924 47.0381 853.737 52.7883C880.879 58.8312 910.377 58.069 938.208 54.3799C1002.51 45.843 1060.11 19.1164 1125.03 13.726C1193.69 8.02457 1265.61 37.0744 1331.96 20.2628",
    stroke: "url(#paint51_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.002 0.617188C-30.8385 3.51363 29.9054 34.4111 107.346 30.3133C168.169 27.0876 227.525 13.953 288.888 14.6543C341.274 15.264 393.14 26.8132 444.867 31.4597C499.989 36.4111 552.914 35.4111 605.31 23.1668C666.113 8.95285 720.147 16.6177 778.614 32.0085C803.758 38.6124 828.274 47.3627 854.147 52.8873C881.628 58.7473 910.237 58.2716 938.368 54.4178C1002.78 45.5883 1060.06 18.8373 1125.21 13.0566C1193.78 6.95887 1266.01 37.7831 1331.92 20.0813",
    stroke: "url(#paint52_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.002 0.5C-30.7586 3.31107 29.8754 34.3914 107.396 30.1413C168.219 26.8058 227.655 13.8907 289.138 14.6468C341.534 15.2932 393.2 27.3302 444.917 32.0865C500.039 37.1537 553.243 35.989 605.33 23.1288C666.603 7.98807 719.877 15.9274 778.903 31.9035C832.827 46.4894 877.254 63.0937 938.318 54.5446C1002.9 45.5016 1059.92 18.9763 1125.29 12.7321C1193.78 6.18922 1266.39 38.6782 1332 20.0495",
    stroke: "url(#paint53_linear_171872_90392)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171872_90392",
    x1: 1036560,
    y1: 10532,
    x2: 1036560,
    y2: 2950.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171872_90392",
    x1: 1036560,
    y1: 10612.5,
    x2: 1036560,
    y2: 2966.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_171872_90392",
    x1: 1036600,
    y1: 10635.3,
    x2: 1036600,
    y2: 2967.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_171872_90392",
    x1: 1036580,
    y1: 10607.4,
    x2: 1036580,
    y2: 2955.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_171872_90392",
    x1: 1036580,
    y1: 10533.6,
    x2: 1036580,
    y2: 2931.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_171872_90392",
    x1: 1036580,
    y1: 10365,
    x2: 1036580,
    y2: 2882.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_171872_90392",
    x1: 1036590,
    y1: 10252.1,
    x2: 1036590,
    y2: 2848.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_171872_90392",
    x1: 1036550,
    y1: 10115.7,
    x2: 1036550,
    y2: 2808.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_171872_90392",
    x1: 1036580,
    y1: 9970.97,
    x2: 1036580,
    y2: 2766.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_171872_90392",
    x1: 1036610,
    y1: 9817.93,
    x2: 1036610,
    y2: 2722.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_171872_90392",
    x1: 1036560,
    y1: 9662.87,
    x2: 1036560,
    y2: 2677.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_171872_90392",
    x1: 1036580,
    y1: 9461,
    x2: 1036580,
    y2: 2620.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_171872_90392",
    x1: 1036550,
    y1: 9316.51,
    x2: 1036550,
    y2: 2579.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_171872_90392",
    x1: 1036560,
    y1: 9187.74,
    x2: 1036560,
    y2: 2541.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_171872_90392",
    x1: 1036550,
    y1: 9086.54,
    x2: 1036550,
    y2: 2511.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_171872_90392",
    x1: 1036610,
    y1: 8999.24,
    x2: 1036610,
    y2: 2484.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_171872_90392",
    x1: 1036580,
    y1: 8955.94,
    x2: 1036580,
    y2: 2470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_171872_90392",
    x1: 1036580,
    y1: 8935.17,
    x2: 1036580,
    y2: 2460.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_171872_90392",
    x1: 1036600,
    y1: 8877.98,
    x2: 1036600,
    y2: 2442.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_171872_90392",
    x1: 1036580,
    y1: 8792.05,
    x2: 1036580,
    y2: 2415.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_171872_90392",
    x1: 1036600,
    y1: 8666.7,
    x2: 1036600,
    y2: 2379.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_171872_90392",
    x1: 1036580,
    y1: 8516.56,
    x2: 1036580,
    y2: 2336.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_171872_90392",
    x1: 1036600,
    y1: 8337.06,
    x2: 1036600,
    y2: 2285.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_171872_90392",
    x1: 1036570,
    y1: 8136.94,
    x2: 1036570,
    y2: 2228.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_171872_90392",
    x1: 1036580,
    y1: 7910.34,
    x2: 1036580,
    y2: 2165.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_171872_90392",
    x1: 1036560,
    y1: 7658.84,
    x2: 1036560,
    y2: 2095.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_171872_90392",
    x1: 1036580,
    y1: 7399.44,
    x2: 1036580,
    y2: 2023.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_171872_90392",
    x1: 1036580,
    y1: 7119.09,
    x2: 1036580,
    y2: 1946.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_171872_90392",
    x1: 1036580,
    y1: 6836.58,
    x2: 1036580,
    y2: 1868.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_171872_90392",
    x1: 1036580,
    y1: 6539.3,
    x2: 1036580,
    y2: 1786.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_171872_90392",
    x1: 1036580,
    y1: 6243.38,
    x2: 1036580,
    y2: 1705.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_171872_90392",
    x1: 1036530,
    y1: 5953.67,
    x2: 1036530,
    y2: 1625.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_171872_90392",
    x1: 1036610,
    y1: 5643.39,
    x2: 1036610,
    y2: 1541.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_171872_90392",
    x1: 1036580,
    y1: 5452.09,
    x2: 1036580,
    y2: 1488.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_171872_90392",
    x1: 1036580,
    y1: 5216.36,
    x2: 1036580,
    y2: 1423.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_171872_90392",
    x1: 1036600,
    y1: 5028.97,
    x2: 1036600,
    y2: 1372.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_171872_90392",
    x1: 1036580,
    y1: 4877.4,
    x2: 1036580,
    y2: 1331.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_171872_90392",
    x1: 1036540,
    y1: 4751.37,
    x2: 1036540,
    y2: 1296.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_171872_90392",
    x1: 1036560,
    y1: 4644.17,
    x2: 1036560,
    y2: 1266.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_171872_90392",
    x1: 1036550,
    y1: 4556.96,
    x2: 1036550,
    y2: 1242.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_171872_90392",
    x1: 1036560,
    y1: 4559.7,
    x2: 1036560,
    y2: 1242.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_171872_90392",
    x1: 1036610,
    y1: 4678.47,
    x2: 1036610,
    y2: 1273.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_171872_90392",
    x1: 1036580,
    y1: 4801.54,
    x2: 1036580,
    y2: 1304.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_171872_90392",
    x1: 1036580,
    y1: 4926.77,
    x2: 1036580,
    y2: 1337.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_171872_90392",
    x1: 1036540,
    y1: 5055.61,
    x2: 1036540,
    y2: 1370.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_171872_90392",
    x1: 1036550,
    y1: 5175.01,
    x2: 1036550,
    y2: 1402.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_171872_90392",
    x1: 1036570,
    y1: 5291.77,
    x2: 1036570,
    y2: 1432.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_171872_90392",
    x1: 1036570,
    y1: 5399.46,
    x2: 1036570,
    y2: 1460.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_171872_90392",
    x1: 1036580,
    y1: 5498.3,
    x2: 1036580,
    y2: 1486.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_171872_90392",
    x1: 1036570,
    y1: 5593.06,
    x2: 1036570,
    y2: 1511.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_171872_90392",
    x1: 1036580,
    y1: 5664.37,
    x2: 1036580,
    y2: 1530.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_171872_90392",
    x1: 1036580,
    y1: 5726.32,
    x2: 1036580,
    y2: 1546.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_171872_90392",
    x1: 1036550,
    y1: 5764.17,
    x2: 1036550,
    y2: 1556.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_171872_90392",
    x1: 1036610,
    y1: 5732.64,
    x2: 1036610,
    y2: 1548.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStayInformedBottomBg);
export default __webpack_public_path__ + "static/media/stay_informed_bottom_bg.69a35e2707e92fd8ffd277b33a3c8980.svg";
export { ForwardRef as ReactComponent };